<kiosk-wizard [step]="2">
  <div class="kiosk-hw100">
    <kiosk-template
      mainTitle="app.components.wizard.steps.something-went-wrong.title"
      subtitle="app.components.wizard.steps.something-went-wrong.sub-title"
      image="something-went-wrong"
    >
    </kiosk-template>
  </div>
</kiosk-wizard>
